import { store } from '../stores/mainStore';

export function create() {
	const m = window.manager;
	m.scene = this;
	m.startSideLoading();

	this.anims.create({ key: 'flair',
		frames: this.anims.generateFrameNumbers('flair', { start: 2, end: 9 }),
		frameRate: 10,
		repeat: -1,
	});
	this.anims.create({key: 'diceExplosion',
		frames: m.scene.anims.generateFrameNumbers('dice_explosion', {start: 0, end: 24}),
		frameRate: 30, repeat: 0,
	});
	this.anims.create({ key: 'poof',
		frames:  this.anims.generateFrameNames('poofNoCloud', {
			start: 1, end: 20,
			prefix: 'poof_no_cloud_', suffix: '.png',
		}),
		frameRate: 30,
		repeat: 0,
		hideOnComplete: true,
	});
	this.anims.create({ key: 'cupSwirl',
		frames: m.scene.anims.generateFrameNames('swirl', {
			start: 1, end: 29, zeroPad: 4,
			prefix: 'swirl', suffix: '.png',
		}),
		frameRate: 30,
		repeat: -1,
	});

	manager.createScene = function (index) {
		store.phaserLoading = false;
		if (store.isImmediateRematch) {
			store.setSpinner(false);
		}
		
		//no customAssets, so all additional loading code remains in rw-sandbox/ors-chance
		const loadNext = () => {
			console.log('456 Create loadNext : gs =', m.gameState , 'to assetLoading')
			setTimeout(() => m.gameState = 'assetsLoaded', 250);
		}
		m.createOnComplete = () => {loadNext();}
		loadNext();
	}
}
